import {
    useSelector as useReduxSelector,
    TypedUseSelectorHook,
} from 'react-redux'
import { RootState } from '../state/store'

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector